import { Grid, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import dayjs from 'dayjs'
import { useMsal } from '@azure/msal-react'
import axios from 'axios'

import RadioButtonGroup from '../../../../components/common/RadioButtonGroup'
import ButtonComponent from '../../../../components/common/button/Button'
import { getDownloadCMEndpoint, postUploadCMEndpoint } from '../../../../common/endpoints'
import { toast } from 'react-toastify'

const DownloadUpload = ({isFormEmpty, formData, setIsLoading, userName, userEmail, handleViewUpload, setFormData, contractType, handleContractChange }) => {
  
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const { instance } = useMsal();

    const downloadFileHandler = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const account = instance?.getAllAccounts()[0];
        instance?.setActiveAccount(account);
        const tokenRequest = {
        scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
        };
        try {
            const tokenResponse = await instance?.acquireTokenSilent(tokenRequest);
            const accessToken = tokenResponse?.accessToken;
    
            const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/${getDownloadCMEndpoint}?userId=${userEmail}&userName=${userName}&cmType=${contractType}`;
            const response = await axios.post(
            url,
            {
              vendorNumbers: formData?.vendorNumber?.map(item => item?.value),
              plantNumbers: formData?.plantNumber?.map(item => item?.value),
              materialNumbers: formData?.materialNumber?.map(item => item?.value),
              agreementNumbers: formData?.agreementNumber?.map(item => item?.value),
              validityStartDate: formData.validityStartDate ? dayjs(formData.validityStartDate).format("DD-MM-YYYY") : null,
              validityEndDate: formData.validityEndDate ? dayjs(formData.validityEndDate).format("DD-MM-YYYY") : null,
              currencies: formData?.currency?.map(item => item?.value),
              companyCodes: formData?.companyCode?.map(item => item?.value),
              purchaseGroups: formData?.purchaseGroup?.map(item => item?.value),
              purchaseOrgs: formData?.purchaseOrg?.map(item => item?.value),
            },
            {
                headers: {
                Authorization: `Bearer ${accessToken}`,
                withCredentials: true,
                },
                responseType: "blob", // Important for Excel download
            }
            );
            if (response.status === 200) {
                const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = downloadUrl;
                const timestamp = dayjs().format("YYYY-MM-DD");
                link.setAttribute(
                "download",
                `AL Data - ${contractType === "NEW" ? "New Year" : "Update"} Contract-${timestamp}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                setIsLoading(false);
                setFormData({
                  vendorNumber: [],
                  plantNumber: [],
                  materialNumber: [],
                  agreementNumber: [],
                  currency: [],
                  companyCode: [],
                  purchaseGroup: [],
                  purchaseOrg: [],
                  validityStartDate: null,
                  validityEndDate: null,
                });
                toast.success("File downloaded successfully", {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
        } catch (error) {
            console.log("API error:", error);
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
        setUploadedFileName(file.name);
        setSelectedFile(file);
        }
    };

    const handleUploadClick = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const handleSubmitUpload = async (event) => {
        event.preventDefault();
        if (!selectedFile) return;
        setIsLoading(true);
        const account = instance?.getAllAccounts()[0];
        instance?.setActiveAccount(account);
        const tokenRequest = {
          scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
        };
        try {
          const tokenResponse = await instance?.acquireTokenSilent(tokenRequest);
          const accessToken = tokenResponse?.accessToken;

          // build URL with required params
          const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/${postUploadCMEndpoint}?userId=${userEmail}&userName=${userName}&cmType=${contractType}`;

          // use FormData for file upload + a JSON payload field
          const fd = new FormData();
          fd.append('file', selectedFile);
          fd.append('payload', JSON.stringify());

          const response = await axios.post(url, fd, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              // do not set Content-Type manually so browser sets multipart boundary
            },
            withCredentials: true,
          });

          if (response.status >= 200 && response.status < 300) {
            // handle success (toast, clear state, etc.)
            setUploadedFileName('');
            setSelectedFile(null);
            toast.success("File Uploaded successfully", {
                position: "top-right",
                autoClose: 3000,
            });
          }
        } catch (error) {
          console.error("Upload error:", error);
        } finally {
          setIsLoading(false);
        }
      };

  return (
    <>
      <div style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "20px",
          marginTop: "20px",
          marginBottom: "20px",
      }}
      >
      <Typography variant="h6" sx={{fontWeight: '500'}}>Excel Download/Upload</Typography>
      <Grid
          item
          xs={6}
          mt={2}
          sx={{
          display: "flex",
          flexDirection: "row",
          // "& .MuiFormControl-root": { width: "100%" },
          "& .MuiFormLabel-root": { fontSize: "14px" },
          "& .MuiInputBase-root>Input": { height: "80% !important" },
          }}
      >
          <RadioButtonGroup
          props={[
              {
              label: "New Year Contract",
              value: "NEW",
              labelPlacement: "end",
              size: "small",
              },
              {
              label: "Update Contract",
              value: "UPDATE",
              labelPlacement: "end",
              size: "small",
              },
          ]}
          value={contractType}
          onChange={handleContractChange}
          name="scheduleType"
          />
          <ButtonComponent
          label="Download in Excel"
          bgColor="#000"
          color="#fff"
          disabled={isFormEmpty}
          onClick={downloadFileHandler}
          />
          <p style={{ marginLeft: '10px' }}></p>
          <input
            ref={fileInputRef}
            type="file"
            accept=".xls,.xlsx,.csv"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <ButtonComponent
            label="Select file"
            bgColor="#000"
            color="#fff"
          //   disabled={isFormEmpty}
            onClick={handleUploadClick}
          />
          {/* show uploaded filename */}
          {uploadedFileName ? (
              <>
              <Typography variant="body2" sx={{ ml: 2, alignSelf: 'center', mr: 2 }}>
                  {uploadedFileName}
              </Typography>
              <ButtonComponent
                  label="Upload"
                  bgColor="#000"
                  color="#fff"
                  onClick={handleSubmitUpload}
              />
              </>
          ) : null}
          <p style={{ marginLeft: '10px' }}></p>
          <ButtonComponent
            label="View and Submit"
            bgColor="#000"
            color="#fff"
            onClick={handleViewUpload}
          />
      </Grid>
      </div>
    </>
  )
}

export default DownloadUpload